import { Component, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ComponentNotes, ReleaseNotes, ReleaseRetrievalService } from 'src/app/services/apiHandler/release-retrieval/release-retrieval.service';

@Component({
  selector: 'app-release-notes-multi',
  templateUrl: './release-notes-multi.component.html',
  styleUrls: ['./release-notes-multi.component.scss']
})
export class ReleaseNotesMultiComponent {

    public releaseNotes: ReleaseNotes[] = [];
    public components!: ComponentNotes;
    public expandedArray: boolean[] = [];
    public loaded: boolean = false;
    public pdfLoading: boolean = false;
    private snackbar = inject(MatSnackBar);
    public error: boolean = false;
    public errorComp: boolean = false;
  
    constructor(private releaseRetrievalService: ReleaseRetrievalService, public translate: TranslateService) {
        releaseRetrievalService.getReleaseNotes('multi').subscribe({
            next: (resp) => {
                this.releaseNotes = JSON.parse(JSON.stringify(resp.body));
                this.releaseNotes.forEach(() => {
                    this.expandedArray.push(false);
                });
            }, error: () => {
                this.error = true;
            }
        });
    }
  
    public toggleBtn(release: any) {
        // option when just one can be open
        for (let i = 0; i < this.expandedArray.length; i++) {
            if (i == release) {
                this.expandedArray[release] = !this.expandedArray[release];
            } else {
                this.expandedArray[i] = false;
            }
        }
        // option when more than one can be open
        //this.expandedArray[release] = !this.expandedArray[release];
    }
  
    public loadComponent(component: string) {
        this.loaded = false;
        this.releaseRetrievalService.getComponentNotes(component).subscribe({
            next: (resp) => {
                this.components = JSON.parse(JSON.stringify(resp.body));
                this.loaded = true;
                this.errorComp = false;
            }, error: () => {
                this.errorComp = true;
                this.loaded = true;
            }
        });
    }
  
    public downloadAll() {
        /**
        * Loads a PDF document from the API via HTTP.
        * - Creates a blob object from the response body
        * - Creates a temporary URL from it and opens it in a new tab
        *      - This triggers the ‘Open or save’ browser dialogue
        * - Releases the generated URL again after 1 minute to avoid memory leaks
        * - Handles possible errors during the HTTP request or opening the new tab
        */
        this.pdfLoading = true;
  
        this.releaseRetrievalService.downloadAllNotes('multi').subscribe({
            next: (data) => {
                /* Check if data is sent from server */
                if (!data.body) {
                    console.error('Response body is empty.');
                    this.pdfLoading = false;
                    this.setPdfErrorSnackBar();
                    return;
                }
  
                /* Create blob and pdf in new tab*/
                const blob = new Blob([data.body], { type: 'application/pdf' });
                const downloadURL = window.URL.createObjectURL(blob);
                const newTab = window.open(downloadURL);
                if (!newTab) {
                    console.warn('Could not open new tab, possible Pop-Up Blocker?');
                    this.setPdfErrorSnackBar();
                }
  
                this.pdfLoading = false;
                /* CleanUp Url after 1 minute*/
                setTimeout(() => {
                    window.URL.revokeObjectURL(downloadURL);
                }, 60000);
            },
            error: (err) => {
                console.error('Error while loading pdf:', err);
                this.pdfLoading = false;
                this.setPdfErrorSnackBar();
            },
        });
    }
  
    private setPdfErrorSnackBar() {
        let message = this.translate.instant('ERROR.PDF_DOWNLOAD');
        this.snackbar.open(message, '', { duration: 3000 });
    }

}
